import { createI18n } from 'vue-i18n'

const messages = {
  'zh-CN': {
    nav: {
      intro: '首页',
      about: '关于我们',
      products: '产品',
      documents: '文档',
      contact: '联系'
    },
    hero: {
      title: '南京双益自控技术有限公司',
      subtitle: '用创新驱动世界，用智能连接未来',
      cta: '探索我们的产品'
    },
    about: {
      title: '关于我们',
      subtitle: '未来科技致力于用创新技术改变世界。我们专注于云计算、人工智能与边缘计算等核心领域。',
      emailLabel: '邮箱',
      phoneLabel: '电话',
      hoursLabel: '营业时间',
      officeLabel: '办公地址',
      email: "contact{'@'}future-tech.example",
      phone: '+86 21 1234 5678',
      hours: '周一至周五 9:00-18:00',
      office: '江苏省南京市江宁区诚基大厦2栋403室',
      mapCoords: {
        lat: 31.93069,
        lon: 118.821083,
        zoom: 2
      }
    },
    products: {
      title: '我们的产品',
      subtitle: '面向未来的解决方案',
      viewAll: '查看全部产品',
      items: [
        { title: '量子云平台', desc: '高性能、低延迟的下一代云计算服务。' },
        { title: '神经网络引擎', desc: '为企业提供端到端的 AI 能力与推理优化。' },
        { title: '边缘智能设备', desc: '在设备端实现实时分析与安全计算。' }
      ]
    },
    contact: {
      title: '联系我们',
      subtitle: '期待与您一起创造非凡',
      name: '姓名',
      email: '邮箱',
      message: '留言',
      send: '发送',
      success: '感谢您的联系！我们会尽快回复。'
    },
    footer: {
      rights: '© 2026 南京双益自控技术有限公司 保留所有权利'
    },
    details: {
      back: '返回',
      notFound: '未找到该产品',
      download: '下载文档',
      downloadPdf: '下载 PDF',
      preview: '预览文档',
      viewDetails: '查看详情'
    },
    lang: {
      zh: '中文',
      en: 'English'
    },
    documents: {
      title: '产品文档',
      subtitle: '下载产品规格、安装指南和技术文档',
      selectProduct: '选择产品',
      selectDescription: '从左侧选择一个产品以查看相关文档',
      preview: '预览',
      download: '下载'
    }
  },
  en: {
    nav: {
      intro: 'Home',
      about: 'About',
      products: 'Products',
      documents: 'Documents',
      contact: 'Contact'
    },
    hero: {
      title: 'Bothfit Technologies Co., Ltd.',
      subtitle: 'Innovation powers the world. Intelligence connects the future.',
      cta: 'Explore Our Products'
    },
    about: {
      title: 'About Us',
      subtitle: 'Future Tech is dedicated to changing the world through innovation, focusing on cloud, AI, and edge computing.',
      emailLabel: 'Email',
      phoneLabel: 'Phone',
      hoursLabel: 'Business Hours',
      officeLabel: 'Office',
      email: "contact{'@'}future-tech.example",
      phone: '+86 21 1234 5678',
      hours: 'Mon-Fri 9:00-18:00',
      office: 'Chengji Building, Nanjing, Jiangsu'
    },
    products: {
      title: 'Our Products',
      subtitle: 'Solutions for the next decade',
      viewAll: 'View all products',
      items: [
        { title: 'Quantum Cloud Platform', desc: 'Next-gen cloud with high performance and ultra-low latency.' },
        { title: 'Neural Network Engine', desc: 'End-to-end AI capabilities with inference optimization.' },
        { title: 'Edge Intelligence Devices', desc: 'On-device real-time analytics and secure computation.' }
      ]
    },
    contact: {
      title: 'Get in Touch',
      subtitle: 'Let’s build something extraordinary together',
      name: 'Name',
      email: 'Email',
      message: 'Message',
      send: 'Send',
      success: 'Thanks for reaching out! We will respond shortly.'
    },
    footer: {
      rights: '© 2026 Bothfit Tech Co., Ltd. All rights reserved.'
    },
    details: {
      back: 'Back',
      notFound: 'Product not found',
      download: 'Download document',
      downloadPdf: 'Download PDF',
      preview: 'Preview document',
      viewDetails: 'View details'
    },
    lang: {
      zh: '中文',
      en: 'English'
    },
    documents: {
      title: 'Product Documents',
      subtitle: 'Download product specifications, installation guides and technical documentation',
      selectProduct: 'Select a Product',
      selectDescription: 'Choose a product from the left to view related documents',
      preview: 'Preview',
      download: 'Download'
    }
  }
}

function detectLocale() {
  const saved = localStorage.getItem('locale')
  if (saved && (saved === 'zh-CN' || saved === 'en')) return saved
  return 'zh-CN' // default Mandarin
}

export const i18n = createI18n({
  legacy: false,
  locale: detectLocale(),
  fallbackLocale: 'en',
  messages
})

export function setLocale(locale) {
  if (locale !== 'zh-CN' && locale !== 'en') return
  i18n.global.locale.value = locale
  localStorage.setItem('locale', locale)
}
